import React from 'react';
import { MagnifyingGlass, BookOpen, Star, User, ListChecks } from '@phosphor-icons/react';

export default function LiteraryReviewModule({ metadata, onChange }) {
  const handleChange = (field, value) => {
    onChange({ ...metadata, [field]: value });
  };

  return (
    <div className="space-y-6">
      {/* Work Being Reviewed */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <BookOpen size={16} />
          Work Being Reviewed (समीक्षा की जा रही कृति) <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={metadata.reviewed_work || ''}
          onChange={(e) => handleChange('reviewed_work', e.target.value)}
          placeholder="Title of the book/work being reviewed"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Author of Reviewed Work */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <User size={16} />
          Author (लेखक) <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={metadata.reviewed_author || ''}
          onChange={(e) => handleChange('reviewed_author', e.target.value)}
          placeholder="Author's name"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Publication Details */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2">
            Publisher (प्रकाशक)
          </label>
          <input
            type="text"
            value={metadata.publisher || ''}
            onChange={(e) => handleChange('publisher', e.target.value)}
            placeholder="Publisher name"
            className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">
            Publication Year (वर्ष)
          </label>
          <input
            type="number"
            value={metadata.publication_year || ''}
            onChange={(e) => handleChange('publication_year', e.target.value)}
            placeholder="Year"
            min="1900"
            max="2100"
            className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
          />
        </div>
      </div>

      {/* Rating */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Star size={16} weight="fill" className="text-yellow-500" />
          Rating (रेटिंग)
        </label>
        <div className="flex gap-2 items-center">
          <input
            type="range"
            min="0"
            max="5"
            step="0.5"
            value={metadata.rating || 0}
            onChange={(e) => handleChange('rating', parseFloat(e.target.value))}
            className="flex-1"
          />
          <span className="text-2xl font-bold text-primary min-w-[60px]">
            {metadata.rating || 0} / 5
          </span>
        </div>
      </div>

      {/* Strengths */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <ListChecks size={16} className="text-green-500" />
          Strengths (गुण)
        </label>
        <textarea
          value={metadata.strengths || ''}
          onChange={(e) => handleChange('strengths', e.target.value)}
          placeholder="What worked well in this work?"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={3}
        />
      </div>

      {/* Weaknesses */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <ListChecks size={16} className="text-red-500" />
          Weaknesses (कमियाँ)
        </label>
        <textarea
          value={metadata.weaknesses || ''}
          onChange={(e) => handleChange('weaknesses', e.target.value)}
          placeholder="Areas that could be improved..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={3}
        />
      </div>

      {/* Recommendation */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <MagnifyingGlass size={16} />
          Recommendation (सिफारिश)
        </label>
        <select
          value={metadata.recommendation || ''}
          onChange={(e) => handleChange('recommendation', e.target.value)}
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        >
          <option value="">Would you recommend this?</option>
          <option value="highly_recommended">Highly Recommended</option>
          <option value="recommended">Recommended</option>
          <option value="mixed">Mixed Feelings</option>
          <option value="not_recommended">Not Recommended</option>
        </select>
      </div>
    </div>
  );
}
